function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 43,
  r: 43
});

var SvgDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 86 86"
}, props), _ref);

export default __webpack_public_path__ + "static/media/dot.03e80b98.svg";
export { SvgDot as ReactComponent };